/* eslint-disable react/prop-types */

import React from 'react';

function PaginationControls({
 currentPage, totalPages, onPageChange, isLoading,
}) {
  return (
    <div className="d-flex justify-content-between p-2">
      <button
        className="btn btn-outline-primary"
        disabled={currentPage === 1 || isLoading}
        onClick={() => onPageChange(currentPage - 1)}
        type="button"
      >
        Previous
      </button>
      <span>
        Page {currentPage} of {totalPages}
      </span>
      <button
        className="btn btn-outline-primary"
        disabled={currentPage === totalPages || isLoading}
        onClick={() => onPageChange(currentPage + 1)}
        type="button"
      >
        Next
      </button>
    </div>
  );
}

export default PaginationControls;
